import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexStudents(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/students`, { params });
}
export function indexStudent(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/students/${id}`, { params });
}
export function indexStudentSkills(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/skills?student_id=${id}`, { params });
}

export function indexStudentNotes(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/notes?student_id=${id}`, { params });
}
export function indexStudentSchedules(
  id: string | number,
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(
    `v1/supervisors/schedules/show_formatted_schedule?student_id=${id}`,
    { params }
  );
}
export function addCertificateRecommendation(
  id: string | number
): Promise<ApiResponse> {
  return Axios.post(`v1/supervisors/students/${id}/send_recommendation`);
}
